export function bindRoute(params) {
    const mixin = {
        data() {
            const state = {};
            const urlParams = new URLSearchParams(window.location.search);

            for (let key in params) {
                // Prefer URL param, fall back to default
                const urlValue = urlParams.get(key);
                state['_bound_' + key] = urlValue !== null ? urlValue : params[key];
            }
            return state;
        },
        computed: {}
    };

    for (let key in params) {
        mixin.computed[key] = {
            get() {
                return this['_bound_' + key];
            },
            set(val) {
                this['_bound_' + key] = val;
                // Write all bound params back to URL, preserving unrelated params (e.g. UTM)
                const urlParams = new URLSearchParams(window.location.search);
                const defaultVal = params[key];

                if (val === defaultVal || val === null || val === undefined) {
                    urlParams.delete(key);
                } else {
                    urlParams.set(key, val);
                }

                const newSearch = urlParams.toString();
                const newUrl = window.location.pathname + (newSearch ? '?' + newSearch : '');
                window.history.replaceState({}, document.title, newUrl);
            }
        };
    }

    return mixin;
}